import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  viewBox: "0 0 50 50"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("polygon", {
      points: "39 46 25 32.87 11 46 11 6 39 6 39 46",
      class: "fill",
      style: {"stroke-width":"0"}
    }, null, -1),
    _createElementVNode("path", {
      d: "M39 6v40L25 32.87 11 46V6zm0-2H11c-1.1 0-2 .9-2 2v40c0 .8.47 1.52 1.2 1.84a2.025 2.025 0 0 0 2.16-.38l12.63-11.84 12.63 11.84a2.03 2.03 0 0 0 2.16.38c.73-.32 1.2-1.04 1.2-1.84V6c0-1.1-.9-2-2-2Z",
      class: "outline",
      style: {"stroke-width":"0"}
    }, null, -1)
  ])))
}
export default { render: render }